import { FunctionComponent, useContext } from 'react';
import { ApplicationLayoutHeader } from 'layouts/ApplicationLayout/components';
import VerifyApplicationContext from 'contexts/VerifyApplicationContext';

const VerifyApplicationHeader: FunctionComponent = () => {
    const context = useContext(VerifyApplicationContext);

    return <ApplicationLayoutHeader branding={context.branding} />;
};

export default VerifyApplicationHeader;
